import { defineEvent } from "@visioni/a3s-analytics";

/** A successful `apiRequest`. Sampled at 10%: it fires on every request; `sample_rate` lets charts scale it back up. */
export const ApiRequestCompleted = defineEvent<{
  method: string;
  path: string;
  status_code: number;
  duration_ms: number;
}>("API Request Completed", { sampleRate: 0.1 });

/**
 * A failed `apiRequest`. Unsampled. No error message or response body is sent:
 * they are free text that can echo user data. Named `…Event` so it does not
 * shadow the `ApiError` class in `request.ts`.
 */
export const ApiErrorEvent = defineEvent<{
  /**
   * - `http_error`: a non-2xx response, or an auth failure from `authenticatedFetch` (401 / 403).
   * - `timeout`: aborted after the request's timeout.
   * - `network_error`: the fetch call itself failed (no response).
   * - `unknown`: anything else, e.g. an unreadable body.
   */
  error_type: "http_error" | "timeout" | "network_error" | "unknown";
  method: string;
  path: string;
  /** Set for `http_error` only. */
  status_code: number | undefined;
  duration_ms: number;
}>("API Error");
